import { setHeaders } from 'features/simulations/utils';
import type { SimulatedVehicleTO } from 'features/simulations-v2/types';
import { useEffect, useState } from 'react';

export type { SimulatedVehicleTO };

const domain = import.meta.env.VITE_SIMULATION_ROUTE;

const useGetSimulationsV2 = () => {
    const [simulations, setSimulations] = useState<SimulatedVehicleTO[] | undefined>(undefined);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isError, setIsError] = useState<boolean>(false);

    const fetchSimulations = async () => {
        const url = `${domain}/simulator-adapter-service/api/v2/simulation`;
        setIsLoading(true);

        try {
            const res = await fetch(url, {
                method: 'GET',
                headers: await setHeaders(),
            });

            const payload = (await res.json()) as SimulatedVehicleTO[];
            setSimulations(payload);
        } catch (error) {
            console.error(error);
            setIsError(true);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (!simulations) {
            fetchSimulations();
        }
    }, [simulations]);

    return {
        simulations: isError ? [] : simulations,
        isLoading,
        isError,
        refresh: fetchSimulations,
    };
};

export default useGetSimulationsV2;
